export const LIST_CAMPAIGN = 'LIST_CAMPAIGN';
export const SAVED_CAMPAIGN = 'SAVED_CAMPAIGN';
export const CAMPAIGN_VALIDATION_RESPONSE = 'CAMPAIGN_VALIDATION_RESPONSE';
export const RESET_QUERY_CAMPAIGN = 'RESET_QUERY_CAMPAIGN';
